import React from 'react';
import * as Sentry from '@sentry/react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { Button, Grid } from '@material-ui/core';
import { signOutUser } from 'global/GlobalActions';
import { dispatch } from 'config/store';
import { setSnackBarObj } from 'reducers/Alerts';

const useStyles = makeStyles(theme => ({
  main: {
    marginTop: 100,
    borderRadius: 12,
    backgroundColor: '#f7edef',
  },
  title: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    padding: 20,
    borderRadius: '12px 12px 0 0',
  },
  message: {
    padding: '30px',
  },
  messageText: {
    fontSize: '16px',
    lineHeight: '30px',
    fontWeight: 500,
  },
  logout: {
    margin: 30,
    cursor: 'pointer',
  },
}));

const PrimaryFallbackDialog = () => {
  const classes = useStyles();
  return (
    <Grid container justify="center" alignItems="center">
      <Grid container item className={classes.main} xs={10} md={5} lg={4}>
        <Grid container justify="center" alignItems="center" className={classes.title}>
          <Typography variant="h3"> Oops! Something went wrong in this page.</Typography>
        </Grid>
        <Grid container alignItems="flex-start" className={classes.message} direction="column">
          <Typography className={classes.messageText}>
            We are sending a report to our administrators to fix this issue.
          </Typography>
          <Typography className={classes.messageText}> Meanwhile, you can try the following:</Typography>
        </Grid>
        <ul>
          <li>Logout and try logging in again.</li>
          <li>Try navigating to a different page.</li>
        </ul>
        <Grid container justify="flex-end" alignItems="center" className={classes.action}>
          <Button
            size="medium"
            color="primary"
            variant="contained"
            className={classes.logout}
            onClick={() => signOutUser('/PagesRegister')}>
            Logout
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const getFallbackUi = fallbackType => {
  switch (fallbackType) {
    case 'primary':
      return <PrimaryFallbackDialog />;
    default:
      dispatch(setSnackBarObj({ message: 'Oops! Something went wrong in this page.', severity: 'error' }));
      return null;
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error);
    console.log('An Error Occured! ', error, errorInfo);
  }

  render() {
    const { children, fallbackType } = this.props;
    if (this.state.hasError === true) {
      return getFallbackUi(fallbackType);
    }
    return children;
  }
}

const wrapWithErrorBoundary = (wrappedComponent, fallbackType) => (
  <ErrorBoundary fallbackType={fallbackType}>{wrappedComponent}</ErrorBoundary>
);

export default wrapWithErrorBoundary;
